const Routes = {
  testResultPreviewURL(uuid) {
    return `${this.rootURL}/test_results/${uuid}`;
  },

  testResultURL(uuid) {
    return `${this.rootURL}/tests/${uuid}`;
  },

  testURL(topicId) {
    return `${this.rootURL}/tests/new?topic_id=${topicId}`;
  }
};

module.exports = Routes;



// WEBPACK FOOTER //
// ./app/javascript/helpers/Routes.js